import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { AddDeviceDataSchemeRequest } from '../models/request/deviceDataScheme/AddDeviceDataSchemeRequest';
import { GetDeviceDataSchemeListPagingAndFilterRequest } from '../models/request/deviceDataScheme/GetDeviceDataSchemeListPagingAndFilterRequest';

export class DeviceDataSchemeService {
    static async getDeviceDataSchemeList() {
        try {
            var inputObj = {

            };

            console.log('SERVICE CALL - getDeviceDataSchemeList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/DeviceDataScheme/getDeviceDataSchemeList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportDeviceDataSchemeList(inputObj: GetDeviceDataSchemeListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportDeviceDataSchemeList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/DeviceDataScheme/exportDeviceDataSchemeList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getDeviceDataSchemeListPagingAndFilter(inputObj: GetDeviceDataSchemeListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetDeviceDataSchemeListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/DeviceDataScheme/GetDeviceDataSchemeListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addDeviceDataScheme(inputObj: AddDeviceDataSchemeRequest) {
        try {
            console.log('SERVICE CALL - AddDeviceDataScheme', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/DeviceDataScheme/AddDeviceDataScheme', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteDeviceDataScheme(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteDeviceDataScheme', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/DeviceDataScheme/deleteDeviceDataScheme', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getDeviceDataSchemeById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getDeviceDataSchemeById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/DeviceDataScheme/getDeviceDataSchemeById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}